export const PRIMARY = {
  DARKEST: '#1C3833',
  DARK: '#00392F',
  DEFAULT: '#004D40',
  LIGHT: '#CCE0DD',
  LIGHTER: '#F0F5F4',
  LIGHTEST: '#F0F5F4',
} as const;
